import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgEdit(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-rtl-mirror": true }, props),
        React.createElement("g", { clipPath: "url(#clip0_19491_1011)" },
            React.createElement("path", { d: "M20.1251 0.875026C21.2961 2.04694 21.2986 3.94932 20.1268 5.1205L19.3305 5.91633L15.0822 1.66801L15.8779 0.871834C17.0497 -0.30068 18.9534 -0.297553 20.1251 0.875026Z", fill: "currentColor" }),
            React.createElement("path", { d: "M17.916 7.33018L13.6685 3.08267L3.87868 12.8786C3.31607 13.4412 3 14.2043 3 15V17.9984H6C6.79565 17.9984 7.55871 17.6824 8.12132 17.1197L17.916 7.33018Z", fill: "currentColor" }),
            React.createElement("path", { d: "M2 21C2 20.4477 2.44772 20 3 20H21C21.5523 20 22 20.4477 22 21C22 21.5522 21.5523 22 21 22H3C2.44772 22 2 21.5522 2 21Z", fill: "currentColor" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_19491_1011" },
                React.createElement("rect", { width: 24, height: 24, fill: "white" })))));
}
export default SvgEdit;
